import _taggedTemplateLiteral from "/codebuild/output/src537278654/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
const Filters = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
const ToolbarActions = _ref2 => {
  let {
    children
  } = _ref2;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
const ActionItem = _ref3 => {
  let {
    children
  } = _ref3;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
const Modals = _ref4 => {
  let {
    children
  } = _ref4;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
const EmptyPage = _ref5 => {
  let {
    children
  } = _ref5;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
const CardBody = _ref6 => {
  let {
    children
  } = _ref6;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
const Content = _ref7 => {
  let {
    children
  } = _ref7;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
const TableRowBody = _ref8 => {
  let {
    children
  } = _ref8;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
const TableCellBody = _ref9 => {
  let {
    children
  } = _ref9;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
const TableCellExpandBody = _ref10 => {
  let {
    children
  } = _ref10;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
const ProfileHeadDiv = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 95%;\n  margin: 0 auto;\n  padding: 1.5rem 0;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n"])));
export { Filters, ToolbarActions, ActionItem, Modals, EmptyPage, CardBody, Content, TableRowBody, TableCellBody, TableCellExpandBody, ProfileHeadDiv };
TableCellBody.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  render: PropTypes.func,
  children: PropTypes.any
};